const translation = {
  MENU_TITLE: 'My Dashboard',
  GENERAL_ERROR: 'An error occurred',
  TRY_AGAIN: 'Try again',
  SEARCH_LABEL: 'What are you looking for in your dashboard?',
  INTERNET_CONNECTION_ERROR: 'A connection error occurred',
  RELOAD_PAGE: 'Reload the page',
};

export default translation;
